import React, { Fragment } from "react";
import { FaPencilAlt } from "react-icons/fa";
import { Row, Col, Card, Container } from "reactstrap";

import { Breadcrumbs, H6,H5, P, Image } from "../../AbstractElements";

const UserDetail = () => {
  return (
    <Fragment>
      <Breadcrumbs
        mainTitle="Profile"
        parent="My"
        title="Profile"
      />
      <Container fluid={true}>
        <div className="edit-profile">
          <Row>
            <Col xl="12">
              <User />
            </Col>
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};
export default UserDetail;

const User = () => {
  const userData = {
    userName: "MARK JECNO",
    email: "mark@example.com",
    phoneNumber: "123-456-7890",
    // profilePicUrl: require("../../../assets/images/user/1.jpg"),
  };

  const readUrl = () => {
    // Implement your readUrl logic if needed
    console.log("Reading URL...");
  };

  return (
    <Card className="card">
      <Row className="mb-4">
        <div className="profile-title d-flex align-items-center">
          <Image
            attrImage={{
              className: "img-70 m-0 rounded-circle",
              alt: "",
              src: userData.profilePicUrl,
            }}
            onClick={readUrl}
          />
          <label htmlFor="profile-image-input" style={{ display: "none" }}>
            <FaPencilAlt className="edit-icon" />
          </label>
          <div className="media-body">
            <H5 attrH5={{ className: "mb-1 text-primary" }}>{userData.userName}</H5>
            <P className="text-muted">Admin</P>
          </div>
        </div>
      </Row>
      <Row className="mb-3">
        <Col sm="6">
          <H6 className="form-label text-secondary">User Name</H6>
          <Card className="p-2 border-light shadow-sm">
            <P className="mb-0">{userData.userName}</P>
          </Card>
        </Col>
        <Col sm="6">
          <H6 className="form-label text-secondary">Email Address</H6>
          <Card className="p-2 border-light shadow-sm">
            <P className="mb-0">{userData.email}</P>
          </Card>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm="6">
          <H6 className="form-label text-secondary">Phone Number</H6>
          <Card className="p-2 border-light shadow-sm">
            <P className="mb-0">{userData.phoneNumber}</P>
          </Card>
        </Col>
        <Col sm="6">
          <H6 className="form-label text-secondary">Profile Picture</H6>
          <Card className="p-2 border-light shadow-sm">
            <Image
              attrImage={{
                className: "img-100",
                alt: "",
                src: userData.profilePicUrl,
              }}
            />
          </Card>
        </Col>
      </Row>
    </Card>
  );
};

